/* eslint-disable @typescript-eslint/no-this-alias */
import _ from 'lodash';
import { IValidationErrorCollection } from '../models/IValidationError';

export class ValidationErrorHelper<T> {
	private validationErrors: IValidationErrorCollection = {};
	private keys: { [normalizedKey: string]: string };

	constructor(validationErrors?: IValidationErrorCollection) {
		this.validationErrors = validationErrors || {};

		this.NormalizeKey = this.NormalizeKey.bind(this);

		const keys = _.keys(this.validationErrors);
		this.keys = {};
		_.each(keys, (key: string) => (this.keys[this.NormalizeKey(key)] = key));
	}
	public NormalizeKey(key: any) {
		return key.toString().toLowerCase();
	}
	public GetKey(normalizedKey: string) {
		return this.keys[normalizedKey];
	}

	public IsValid(key: T) {
		const normalizedKey = this.NormalizeKey(key);
		if (_.has(this.keys, normalizedKey)) {
			return false;
		}
		return true;
	}
	public IsAllValid(keys: T[]) {
		const that = this;
		for (const key of keys) {
			const normalizedKey = this.NormalizeKey(key);
			if (_.has(that.keys, normalizedKey)) {
				return false;
			}
		}
		return true;
	}
	public Errors(key: T) {
		const normalizedKey = this.NormalizeKey(key);
		const referenceKey = this.GetKey(normalizedKey);
		if (_.has(this.keys, normalizedKey)) {
			return this.validationErrors[referenceKey] || [];
		}
		return [];
	}
	public AllErrors(keys: T[]) {
		const that = this;
		for (const key of keys) {
			const normalizedKey = this.NormalizeKey(key);
			const referenceKey = this.GetKey(normalizedKey);
			if (_.has(that.keys, normalizedKey)) {
				return that.validationErrors[referenceKey] || [];
			}
		}
		return [];
	}
}
